module.exports = __webpack_public_path__ + "static/img/lv3.0fb17a09.png";